<template>
  <div>
    <div id="widthref" class="pbc-post-width"></div>
    <slot name="default" />
    <template v-for='(post,i) in posts'>

      <div class="w-full md:max-w-md" :key='"prompt-" + post.id' >
        <slot name="before-post" :i='i' :post='post' />
      </div>
      <pbc-post v-if='post.type === "post"'
                v-observe-visibility='visibilityChanged'
                @reply="reply(post)"
                @view-post='onViewPost($event, i)'
                :ignore-global-pause='ignoreGlobalPause'
                class='pbc-post pbc-post-width'
                :id='post.id'
                :num="i"
                :key='post.id'
                :thumbnail="post.image"
                :title="post.title"
                :body="post.body"
                :user="post.author"
                :upvotes="post.upvotes"
                :downvotes="post.downvotes"
                :fetch='i>= highestIndexVisible - 2 && i < highestIndexVisible + 3'
                :parent='post.parent'
                :clips='post.clips'
                :replies='post.replies'
                :post='post'
                :visible='!!isNext[post.id]'
                :data-postid='post.id'
                :data-num='"" + i'
                :style='postStyle'
                />

        <pbc-text-post v-else-if='post.type === "text"'
                       v-observe-visibility='visibilityChanged'
                       class='flex-none pbc-post-width'
                       :key='post.id'
                       :id='post.id'
                       :body="post.body"
                       :user="post.author"
                       :upvotes="post.upvotes"
                       :downvotes="post.downvotes"
                       :parent='post.parent'
                       :replies='post.replies'
                       :post='post'
                       :data-postid='post.id'
                       :data-num='"" + i'
                       :style='postStyle'
                       />

        <pbc-image-post v-else-if='post.type === "image"'
                       v-observe-visibility='visibilityChanged'
                       class='pbc-post flex-none pbc-post-width'
                       @view-post='onViewPost($event, i)'
                       :key='post.id'
                       :id='"post-" + i'
                       :title="post.title"
                       :image="post.image"
                       :aspect="post.aspect"
                       :user="post.author"
                       :upvotes="post.upvotes"
                       :downvotes="post.downvotes"
                       :parent='post.parent'
                       :replies='post.replies'
                       :post='post'
                       :data-postid='post.id'
                       :data-num='"" + i'
                       :style='postStyle'
                       />
    </template>
    <slot name="after" />
    <!--
    <div class="pbc-z-level-3 fixed top-0 left-0 right-0 bg-black text-white">
      {{lowestIndexVisible}} / {{highestIndexVisible}}
    </div>
    -->

  </div>
</template>
<script>
import gql from 'graphql-tag'
import { debounce, throttle, compact, range } from 'lodash';
import PbcPost from '@ui/molecules/PbcPost.vue';
import PbcTextPost from '@ui/molecules/PbcTextPost.vue';
import PbcImagePost from '@ui/molecules/PbcImagePost.vue';
//import TopReplies from '@ui/organisms/TopReplies.vue';

export default {
  inject: ['api'],
  props: {
    posts: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'unknown'
    },
    ignoreGlobalPause: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const isVisible = {};
    const isNext = {};

    this.posts.forEach( ({id},i) => {
      if ( i < 2 ) {
        isNext[id] = true;
      } else {
        isNext[id] = false;
        isVisible[id] = false;
      }
    });

    const doVisibility = debounce(this._doVisibility, 200);
    return {
      isVisible,
      isNext,
      highestIndexVisible:0,
      lowestIndexVisible:0,
      doVisibility,
      postStyle:{}
    }
  },
  mounted() {
    const bb = this.$el.getBoundingClientRect();
    const screenHeight = window.innerHeight;

    const height = Math.floor(Math.min(screenHeight - 64, bb.width * 15/9));
    if (false && height > 200) {
      this.postStyle.height = height + 'px';
      this.postStyle['min-height'] = height + 'px';
      this.postStyle['max-height'] = height + 'px';
    }
  },
  components: {
    PbcPost,
    PbcTextPost,
    PbcImagePost,
    //TopReplies
  },
  computed:{
  },
  methods: {
    makeNextVisible() {

      let lowIndex = this.lowestIndexVisible - 2;
      //let highIndex = (this.highestIndexVisible === -1 ? this.posts.length : this.highestIndexVisible + 3);
      let numberToVisible = 3;
      let i = Math.max(0,this.highestIndexVisible);
      let highIndex = this.highestIndexVisible;
      while (numberToVisible > 0 && i < this.posts.length) {
        const post = this.posts[i];
        if (post.type === 'post') {
          numberToVisible--;
          highIndex = i;
        }
        i++;
      }
      const makeVisible = range(lowIndex, highIndex + 1);

      for (let i = 0; i < this.posts.length; i++) {
        const post = this.posts[i];
        if (makeVisible.includes(i)) {
          this.$set(this.isNext, post.id, true);
        } else {
          this.$set(this.isNext, post.id, false);
        }
      }
    },
    calculateVisiblity() {
      const prevHighestIndex = this.highestIndexVisible;
      this.highestIndexVisible = -1;
      this.lowestIndexVisible = 99999;
      for (let i = 0; i < this.posts.length; i++) {
        const post = this.posts[i];
        const visible = this.isVisible[post.id];
        if (visible) {
          if (i < this.lowestIndexVisible) {
            this.lowestIndexVisible = i;
          }
          if (i >= this.highestIndexVisible) {
            this.highestIndexVisible = i;
          }
        }

      }

      if (this.highestIndexVisible === -1 && this.lowestIndexVisible > 10000) {
        this.lowestIndexVisible = 0;
        this.highestIndexVisible = 0;
        this.prevHighestIndex = 0;
      }
      if (this.highestIndexVisible > prevHighestIndex) {
        this.$emit('load-more', this.highestIndexVisible);
        const i = this.highestIndexVisible;
        const post = this.posts[i];
        this.$ana.track({
          eventAction:'ui',
          eventCategory:'scrollPost',
          extra:{
            i,
            type:this.type,
            post:post.id
          }
        });
        this.$store.commit('viewedPost');
      }
    },
    _doVisibility() {
      this.makeNextVisible();
    },
    visibilityChanged(visible, data) {
      const el = data.target;
      const i = parseInt(el.dataset.num);
      const id = el.dataset.postid;

      this.$set(this.isVisible, id, visible);

      this.calculateVisiblity();
      this.doVisibility();

    },
    onViewPost(post, i) {
      this.$emit('view-post', {post,i});
    },
    reply(post) {
      this.$emit("reply", post);
    },
    play(post) {
      this.$router.push({
        name:'play',
        params:{
          id:post.id
        }
      });
    },
  }
}
</script>
<style>
body {
}
</style>
